import { forwardRef } from "react";

type SpacerProps = {
    size?: number;
    direction?: "horizontal" | "vertical" | "garo" | "sero";
    fullSize?: boolean;
}

const Spacer = forwardRef<HTMLDivElement, SpacerProps>(({size = 100, direction = "horizontal", fullSize = false}, ref) => {
    let width = (direction === "horizontal" || direction === "garo") ? `${fullSize ? "100%" : `${size}px`}` : '1px';
    let height = (direction === "vertical" || direction === "sero") ? `${fullSize ? "100%" : `${size}px`}` : '1px';

    return (
        <div
            ref={ref}
            style={{width, height}}
        >
        </div>
    )
});

Spacer.displayName = "Spacer";

export default Spacer;